import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/Services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/Services/website.service';
import { appConfig } from 'src/app/app.config';
import { AdminService } from 'src/app/Services/admin.service';
import { saveAs } from 'file-saver';
declare var $
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  base_address: string = appConfig.apiUrl + 'admin/';

  quarter:Number = 1;
  year:Number = 2019;

  kpis:any;
  selectedKpis=[];
  allKpis = 'true';

  bcs: any;
  selectedBc=[];
  selectedBcType=2;
 
  outputList:any;
  selectedOutput=[];
  allOutputs = 'true';
 
  baseYear=0;
  baseQuarter=0;
  yearsList:any;
  searchText = '';



  constructor(private loader: LoaderService,
    private route: ActivatedRoute,
    private adminService: AdminService,
    private toastr: ToastrService) { }

  ngOnInit() {
    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);
    
    // 
    this.bcs = this.route.snapshot.data.bcs.result;
    this.kpis = this.route.snapshot.data.kpis.result;
    this.adminService.LoadYearsList().subscribe((data:any) => {
      console.log(data);
      this.yearsList = data.result;
      this.year = (new Date()).getFullYear() - 1;
      this.quarter = 4;//Math.floor(((new Date()).getMonth() +1) / 4)+1;
      });
    this.adminService.GetActiveGpwOutputs().subscribe((data:any) => {
      console.log(data);
      this.outputList = data.result;
      // this.outputList.forEach(x=>{
      //   if(x.gpwoutput.length>150)
      //   x.gpwoutput=x.gpwoutput.substring(0,150)+'...';
      //   });
    });

  }



  validateValues(){
    if(this.selectedBcType == 3 && this.selectedBc.length == 0)
    {
      this.toastr.error('please select at least 1 budget center');
      return false;
    }
    if(this.allKpis == 'false' && this.selectedKpis.length == 0 )
    {
      this.toastr.error('please select at least 1 kpi');
      return false;
    }
    if(this.allOutputs == 'false' && this.selectedOutput.length == 0 )
    {
      this.toastr.error('please select at least 1 output');
      return false;
    }
    
    const data = {
      BcType : Number(this.selectedBcType),
      AllKpis : Boolean(this.allKpis),
      AllOutputs : Boolean(this.allOutputs),
      BcsIds : this.selectedBc,
      KpisIds : this.selectedKpis,
      OutputIds : this.selectedOutput,
      Year : +this.year,
      Quarter : this.quarter
    };
    console.log(data);
    this.loader.showLoader();
    this.adminService.DownloadWebReporting(data).subscribe((file)=>{
      saveAs(file,'Bcs-Kpis-Report.xlsx');
      setTimeout(() => {
        this.loader.hideLoader();
      }, 300);
    },(err)=>{
      setTimeout(() => {
        this.loader.hideLoader();
      }, 300);
    });
    return true;
  }

  // searchTextchanged()
  // {
  //   console.log(this.searchText);
  //   if(this.searchText.length == 0)
  //   {
  //     this.filteredBcs = this.bcs;
  //   }
  //   else{
  //     this.filteredBcs = this.bcs.filter(x=>x.value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
  //   }
  // }
}
